import { render, staticRenderFns } from "./FizzClub.vue?vue&type=template&id=2fe9f5e0&scoped=true&"
import script from "./FizzClub.vue?vue&type=script&lang=js&"
export * from "./FizzClub.vue?vue&type=script&lang=js&"
import style0 from "./FizzClub.vue?vue&type=style&index=0&id=2fe9f5e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe9f5e0",
  null
  
)

export default component.exports